import { render, staticRenderFns } from "./FormGroupComponent.vue?vue&type=template&id=024d4538&scoped=true&"
import script from "./FormGroupComponent.vue?vue&type=script&lang=js&"
export * from "./FormGroupComponent.vue?vue&type=script&lang=js&"
import style0 from "./FormGroupComponent.vue?vue&type=style&index=0&id=024d4538&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024d4538",
  null
  
)

export default component.exports